import { css } from 'styled-jsx/css';

export default css`
  button {
    color: #b4b4b4;
    background: transparent;
    text-decoration: underline;
    border: 0;
  }

  .tag-debugger {
    font-size: 12px;
    line-height: 1;
    padding: 10px;
    border: 1px solid #333;
    margin: 12px 0;
  }

  .tag-debugger pre {
    background: #333;
    color: #b4b4b4;
    padding: 10px;
  }
`;
